import React from 'react';
export var defaultBackgroundContext = {};
export var BackgroundContext = /*#__PURE__*/React.createContext(defaultBackgroundContext);